import { ApplicationInsights } from "@microsoft/applicationinsights-web";

import { LayoutHandler } from "Core/Layouts";
import {
    Page,
    MainPage,
    ParentChildMappingPage,
    MappingPage,
    IfcImportPage,
    IfcExportPage,
    VersionPage,
    RefreshCachePage,
} from "Core/Pages";
import { AppContext } from "Core/AppContext";
import { QueryParameter } from "Core/QueryParameter";
import { Navigation } from "Core/Navigation";
import { ApplicationParameter } from "Core/ApplicationParameter";
import { ReportPage } from "./Pages/ReportPage";
import { FileDownloadPage } from "./Pages/FileDownloadPage";
import { Breadcrumb } from "./Breadcrumb";
import { Util } from "./Util";
import { Configuration } from "Configuration/Configuration";
import CancellationToken from "cancellationtoken";

/**
 * @hidden
 */
export class Router {
    private layoutHandler: LayoutHandler;
    private router: kendo.Router;
    public currentPage: Page;

    private container: JQuery;
    private appInsights: ApplicationInsights;

    private pageLoadCancellationTokenSource: {
        token: CancellationToken;
        cancel: (reason?: any) => void;
    };

    initialize(container: JQuery, root: string, appInsights: ApplicationInsights): void {
        this.container = container;
        this.appInsights = appInsights;
        this.router = new kendo.Router({
            pushState: true,
            root: root,
        });

        this.layoutHandler = new LayoutHandler(AppContext.current.appViewModel);
    }

    start(): void {
        this.router.bind("init", () => {
            QueryParameter.initialize();
            this.layoutHandler.initialize(this.container);
            $(window).on("resize", () => this.onResize(true));
            this.onResize(true);
        });
        this.router.bind("change", (e: kendo.RouterChangeEvent) => {
            if (this.currentPage) {
                if (!this.currentPage.canNavigate()) {
                    e.preventDefault();
                    return;
                }
                if (this.pageLoadCancellationTokenSource) {
                    this.pageLoadCancellationTokenSource.cancel();
                }

                this.currentPage.dispose();
                this.currentPage = undefined;
            }
            if (e.url === "" || e.url === "/") {
                // e.preventDefault();
                if (AppContext.current.environment.UserStartPage && AppContext.current.environment.UserStartPage != "/") {
                    e.preventDefault();
                    Navigation.navigate(AppContext.current.environment.UserStartPage);
                    $("body").removeClass("open");
                    return;
                }
            }

            if (e.backButtonPressed) {
                Breadcrumb.removeLast();
            }

            QueryParameter.addFromObject(e.params);
            ApplicationParameter.clear();
            ApplicationParameter.initialize(AppContext.current.environment.ApplicationParameters);
            this.layoutHandler.update();

            if (this.appInsights) {
                this.appInsights.trackPageView({
                    name: e.url,
                });
            }

            if (QueryParameter.get("back") === "1") {
                $("body").addClass("dms-backbutton");
            } else {
                $("body").removeClass("dms-backbutton");
            }
        });

        this.router.route("main", () => {
            let page = new MainPage(AppContext.current.serviceProvider);
            this.showPage(page);
        });
        this.router.route("version", () => {
            let page = new VersionPage(AppContext.current.serviceProvider);
            this.showPage(page);
        });
        this.router.route("refreshcache", () => {
            let page = new RefreshCachePage(AppContext.current.serviceProvider);
            this.showPage(page);
        });

        this.router.route("dms/:mappingName", (mappingName: string, params: any) => {
            let page: Page = null;
            if (this.layoutHandler.currentContentMode == "parentchild") {
                page = new ParentChildMappingPage(mappingName, AppContext.current.serviceProvider);
            } else {
                page = new MappingPage(mappingName, AppContext.current.serviceProvider);
            }

            this.showPage(page);
        });
        this.router.route("ifc/import", (params: any) => {
            let page = new IfcImportPage(AppContext.current.serviceProvider);
            this.showPage(page);
        });
        this.router.route("ifc/export", (params: any) => {
            let page = new IfcExportPage(AppContext.current.serviceProvider);
            this.showPage(page);
        });
        this.router.route("dmsconfig", () => {
            Navigation.navigateBrowser("~/DMSConfig");
        });

        this.router.route("leavedmsconfig", () => {
            let url = Navigation.getUrl("~/", true);

            // remove the string DMSConfig/ from the url
            url = url.replace("DMSConfig/", "");

            window.location.href = "/" + url;
        });
        this.router.route("reports/*suffix", (suffix: string) => {
            const page = new ReportPage(suffix, AppContext.current.serviceProvider);
            this.showPage(page);
        });
        this.router.route("filedownload", () => {
            const fileId = QueryParameter.get("fileid");
            const objectId = QueryParameter.get("objectid");
            const tableName = QueryParameter.get("tablename");
            if (fileId && objectId && tableName) {
                const page = new FileDownloadPage(AppContext.current.serviceProvider, Number(fileId), Number(objectId), tableName);
                this.showPage(page);
            }
        });
        this.router.start();
    }

    private showPage(page: Page) {
        this.pageLoadCancellationTokenSource = CancellationToken.create();
        this.layoutHandler.render(page, this.pageLoadCancellationTokenSource.token);
        this.currentPage = page;
        this.onResize();
    }

    navigate(url: string) {
        kendo.history.current = "__";
        this.router.navigate(url);
    }

    private onResize(adjustMenu: boolean = false): void {
        if (adjustMenu) {
            let width = $(window).width();
            $("body").removeClass("dms-mobile");
            $("body").removeClass("dms-navbar-mini");

            if (width > 1024) {
                const menuState = Util.getLocalStorageItem("dms-menu-state");

                if ((menuState == undefined && Configuration.isDmsConfig) || Util.getLocalStorageItem("dms-menu-state") == "true") {
                    $("body").addClass("dms-navbar-mini");
                }
            } else if (width >= 576 && width <= 1024) {
                $("body").addClass("dms-navbar-mini");
            } else if (width < 576) {
                $("body").addClass("dms-mobile");
            }
        }

        if (this.layoutHandler) {
            this.layoutHandler.resize();
        }

        if (this.currentPage) {
            this.currentPage.resize();
        }
    }
}
